import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    console.log("[static-modal] controller connected", this.panelTarget);
  }

  open(event) {
    event.preventDefault();
    this.panelTarget.classList.remove("hidden");
  }

  close(event) {
    event.preventDefault();
    this.panelTarget.classList.add("hidden");
  }
}
